/*
 * @Description: 操作类的有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  条: '条',
  取消: '取消',
  确定: '确定',
  保存: '保存',
  删除: '删除',
  修改: '修改',
  转化: '转化',
  分享: '分享',
  更多: '更多',
  复制: '复制',
  下载: '下载',
  编辑: '编辑',
  重置: '重置',
  作废: '作废',
  关闭: '关闭',
  提交: '提交',
  导入: '导入',
  收起: '收起',
  状态: '状态',
  展开: '展开',
  拨打: '拨打',
  转移: '转移',
  查看: '查看',
  新增: '新增',
  操作: '操作',
  已选择: '已选择',
  列设置: '列设置',
  创建人: '创建人',
  保存失败: '保存失败',
  保存成功: '保存成功',
  暂不确定: '暂不确定',
  创建时间: '创建时间',
  添加跟进: '添加跟进',
  添加明细: '添加明细',
  全屏展示: '全屏展示',
  退出全屏: '退出全屏',
  模板导入: '模板导入',
  全部导出: '全部导出',
  批量转移: '批量转移',
  批量删除: '批量删除',
  导出出错: '导出出错',
  操作失败: '操作失败',
  刷新失败: '刷新失败',
  查询失败: '查询失败',
  操作成功: '操作成功',
  获取失败: '获取失败',
  编辑失败: '编辑失败',
  新增失败: '新增失败',
  温馨提示: '温馨提示',
  详细信息: '详细信息',
  关联成功: '关联成功',
  展开更多: '展开更多',
  点击收起: '点击收起',
  最后更新人: '最后更新人',
  最后更新时间: '最后更新时间',
  保存并关闭: '保存并关闭',
  全选: '全选',
  清空: '清空'
};
